import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { customCell, dateCell, GridPanel } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import style from "../../../../assets/editor.module.scss";
import Endpoint from "../../../../services/api/endpoint";
import { hasPermission } from "../../../../services/authentication";
import { Permission } from "../../../../utils/enums";
import NoteEditor from "../../followup/note";

interface IProps {
	projectId: number;
}

const OpportunityNotes: React.FC<IProps> = (props: IProps) => {
	const { t } = useTranslation();

	return (
		<GridPanel
			className={style.tabGrid}
			listEndpoint={Endpoint.ProjectNotesList}
			listUrlArguments={{ projectId: props.projectId }}
			endpoint={Endpoint.ProjectNotes}
			addScreen={{
				screen: NoteEditor,
				isAllowed: hasPermission(Permission.ProjectsUpdate),
				extraProps: { projectId: props.projectId }
			}}
			editScreen={{
				screen: NoteEditor,
				isAllowed: hasPermission(Permission.ProjectsUpdate),
				extraProps: { projectId: props.projectId }
			}}
			delete={{ isAllowed: hasPermission(Permission.ProjectsUpdate), urlArguments: { projectId: props.projectId } }}
			localLoader
		>
			<GridColumn field="creator.fullName" title={t("creator")} />
			<GridColumn field="createdDate" title={t("createdDate")} cell={customCell(dateCell("yyyy-MM-dd HH:mm"))} filter="date" />
			<GridColumn field="content" title={t("note")} />
		</GridPanel>
	);
};

export default OpportunityNotes;
